import React from "react";
import styles from "./SectionC.module.css";
import Principle1 from "./SectionCPrinciples/Principle1";
import Principle2 from "./SectionCPrinciples/Principle2";
import Principle3 from "./SectionCPrinciples/Principle3";
import Principle4 from "./SectionCPrinciples/Principle4";
import Principle5 from "./SectionCPrinciples/Principle5";
import Principle6 from "./SectionCPrinciples/Principle6";
import Principle7 from "./SectionCPrinciples/Principle7";
import Principle8 from "./SectionCPrinciples/Principle8";
import Principle9 from "./SectionCPrinciples/Principle9";

const SectionC = () => {
  return (
    <div className={styles.sectionC}>
      <div className={styles.title}>SECTION C: PRINCIPLE WISE PERFORMANCE DISCLOSURE</div>
      <Principle1 styles={styles} />
      <Principle2 styles={styles} />
      <Principle3 styles={styles} /> 
      <Principle4 styles={styles} />
      <Principle5 styles={styles} />
     
        <Principle6 styles={styles} />
      <Principle7 styles={styles} />
      <Principle8 styles={styles} />
       <Principle9 styles={styles} /> 
    </div>
  );
};

export default SectionC;
